import React, { MutableRefObject, useEffect } from 'react';

export type PrintPageActions = {
    email: MutableRefObject<null | (() => Promise<void>)>;
    print: MutableRefObject<null | (() => Promise<void>)>;
}

export const PrinterDependencyInversionContext = React.createContext<
    PrintPageActions
    | undefined
>(undefined);

export const usePrinterDependencyInversion = () => {
  const context = React.useContext(PrinterDependencyInversionContext);

  if (!context) {
    throw new Error('No PrinterDependencyInversionContext found. This hook have to be used only inside appropriate context provider');
  }
  return context;
};

export const usePrinterActions = () => {
  const context = usePrinterDependencyInversion();

  return {
    email: context.email,
    print: context.print,
  };
};

export const useSetPrinterActions = (
  emailExecutor: () => Promise<void>,
  printExecutor: () => Promise<void>,
) => {
  const context = usePrinterDependencyInversion();

  useEffect(() => {
    context.email.current = emailExecutor;
    context.print.current = printExecutor;

    // console.log('useSetPrinterActions', emailExecutor, printExecutor);

    return () => {
      context.email.current = null;
      context.print.current = null;
      // console.log('useSetPrinterActions cleanup');
    };
  }, [context, emailExecutor, printExecutor]);
};
